export const countriesEU = [
  {
    value: 'BE',
    label: 'Belgien',
  },
  {
    value: 'BG',
    label: 'Bulgarien',
  },
  {
    value: 'DK',
    label: 'Dänemark',
  },
  {
    value: 'DE',
    label: 'Deutschland',
  },
  {
    value: 'EE',
    label: 'Estland',
  },
  {
    value: 'FI',
    label: 'Finnland',
  },
  {
    value: 'FR',
    label: 'Frankreich',
  },
  {
    value: 'GR',
    label: 'Griechenland',
  },
  {
    value: 'IE',
    label: 'Irland',
  },
  {
    value: 'IT',
    label: 'Italien',
  },
  {
    value: 'HR',
    label: 'Kroatien',
  },
  {
    value: 'LV',
    label: 'Lettland',
  },
  {
    value: 'LT',
    label: 'Litauen',
  },
  {
    value: 'LU',
    label: 'Luxemburg',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'NL',
    label: 'Niederlande',
  },
  {
    value: 'AT',
    label: 'Österreich',
  },
  {
    value: 'PL',
    label: 'Polen',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'RO',
    label: 'Rumänien',
  },
  {
    value: 'SE',
    label: 'Schweden',
  },
  {
    value: 'SK',
    label: 'Slowakei',
  },
  {
    value: 'SI',
    label: 'Slowenien',
  },
  {
    value: 'ES',
    label: 'Spanien',
  },
  {
    value: 'CZ',
    label: 'Tschechien',
  },
  {
    value: 'HU',
    label: 'Ungarn',
  },
  {
    value: 'CY',
    label: 'Zypern',
  }
]
